/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const Star = ({ size = 16, fill, ...rest }: IconProps) => {
  const { colors } = useTheme()
  fill = fill ?? colors.text

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 10 11"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.66713 1.02447C4.7719 0.702009 5.2281 0.702009 5.33287 1.02447L6.2685 3.90405C6.31536 4.04826 6.44974 4.1459 6.60137 4.1459H9.62915C9.9682 4.1459 10.1092 4.57976 9.83487 4.77905L7.38535 6.55874C7.26268 6.64786 7.21135 6.80584 7.25821 6.95005L8.19384 9.82963C8.29861 10.1521 7.92955 10.4202 7.65525 10.2209L5.20573 8.44126C5.08305 8.35214 4.91695 8.35214 4.79428 8.44126L2.34475 10.2209C2.07045 10.4202 1.70139 10.1521 1.80616 9.82963L2.74179 6.95005C2.78865 6.80584 2.73732 6.64786 2.61465 6.55874L0.165125 4.77905C-0.109174 4.57976 0.0317971 4.1459 0.37085 4.1459H3.39863C3.55025 4.1459 3.68464 4.04826 3.7315 3.90405L4.66713 1.02447Z"
        fill={fill}
      />
    </svg>
  )
}
